import request from '@/utils/request'

/**
 * 根据车辆ID、客户ID查询订单ID（个人订单、企业子订单）
 * @param {number} data.carId 车辆id
 * @param {number} data.customerId 客户id
 * @param {number} data.orderBizType 订单类型 10-个人订单 20-企业子订单
 * @param {array} data.orderStates 订单状态
 * @returns
 */
export function getRentOrderIds(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/getRentOrderId',
    method: 'POST',
    data,
  })
}

// 根据车辆ID查询订单ID（企业主订单）（新增）
export function getLeaseOrderIds(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/renewal/ent/getIds',
    method: 'POST',
    data,
  })
}

// 续约订单列表
// 个人订单、企业子订单（新增）
export function getRentOrderRenewalList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/related/list',
    method: 'POST',
    data,
  })
}

// 脱敏个人续约订单列表
export function getSensitiveRentOrderRenewalList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/related/list/sensitive',
    method: 'POST',
    data,
  })
}

// 企业主订单（新增）
export function getLeaseOrderRenewalList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/renewal/list',
    method: 'POST',
    data,
  })
}

// 订单详情
// 个人订单、企业子订单（已有）
export function getRentOrderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail',
    method: 'POST',
    data,
  })
}

// 企业主订单（已有）
export function getLeaseOrderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/detail',
    method: 'POST',
    data,
  })
}


// 获取原订单押金（个人订单、企业子订单）（新增）
export function getRentOrderDepositReceived(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/deposit/received',
    method: 'POST',
    data,
  })
}

export function addPersonalOrderRenewalB(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/create',
    method: 'POST',
    data,
    headers: {
      _che_error_code: [22049],
    },
  })
}

// 企业子订单（已有）
export function addEnterpriseSubOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/add/car',
    method: 'POST',
    data,
  })
}
export function addEnterpriseSubOrderRenewalB(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/create/car',
    method: 'POST',
    data,
    headers: {
      _che_error_code: [22049],
    },
  })
}
// 企业主订单（新增）
export function addEnterpriseOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/renewal/ent/add',
    method: 'POST',
    data,
  })
}

// 作废（已有）
export function invalidContract(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/record/invalid',
    method: 'POST',
    data,
  })
}

// 查询状态（新增）
export function queryContractState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/record/queryContractState',
    method: 'POST',
    data,
  })
}

// 合同模板预览接口（已有）
export function previewContractTemplate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/preview',
    method: 'POST',
    data,
  })
}

// 批量续约
// 上传（企业子订单）（新增）
export function batchUploadEnterpriseSubOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/batch/import',
    method: 'POST',
    data,
  })
}

// 读缓存（企业子订单）（新增）
export function previewEnterpriseSubOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/preview',
    method: 'POST',
    data,
  })
}

// 单个删除（企业子订单）（新增）
export function removeEnterpriseSubOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/remove',
    method: 'POST',
    data,
  })
}

// 导出错误数据（企业子订单）（新增）
export function exportEnterpriseSubOrderRenewal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/renewal/export',
    responseType: 'blob',
    method: 'POST',
    isExport: true,
    data,
  })
}

// 上传文件（已有）
export function uploadFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/fs/standard/upload',
    method: 'POST',
    data,
  })
}

// 租赁中数据看板接口
// 租赁中订单信息
export function getLeaseOrderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/leaseOrderInfo',
    method: 'POST',
    data,
  })
}

// 租赁中订单、租赁中新建订单、续约订单 图表
export function getLeaseOrderNum(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/leaseOrderNum',
    method: 'POST',
    data,
  })
}

// 风控订单信息
export function getRiskOrderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/riskOrderInfo',
    method: 'POST',
    data,
  })
}

// 司机履约风控、逾期催收 图表
export function getRiskOrderChart(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/riskOrderChart',
    method: 'POST',
    data,
  })
}

// 逾期客户占比 饼图
export function getOverdueCustomer(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/overdueCustomer',
    method: 'POST',
    data,
  })
}

// 逾期金额客户top10
export function getOverdueTop(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/overdueTop',
    method: 'POST',
    data,
  })
}

// 脱敏逾期金额客户top10
export function getSensitiveOverdueTop(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/lease/data/board/overdueTop/sensitive',
    method: 'POST',
    data,
  })
}
